import rosterGames from '../data/rosterGames.json'
import rosterClubs from '../data/all_clubs_roster.json'

export interface Player {
  name?: string
  surname: string
  position?: string
  games_2024?: number
  games_2025?: number
}

export interface GameData {
  gameNumber: number
  club: string
  clubName?: string // For backwards compatibility
  players: Player[] | string[]
  uniqueLetters?: number
  includedLetters?: string
  notIncludedLetters?: string
}

export interface Club {
  name: string
  id?: string
}

// Transform roster data to common format
function transformRosterData(): GameData[] {
  return rosterGames.map(game => ({
    gameNumber: game.gameNumber,
    club: game.club,
    clubName: game.club,
    players: game.players.map(player => ({
      name: player.name,
      surname: player.surname,
      position: player.position,
      games_2024: player.games_2024,
      games_2025: player.games_2025
    })),
    uniqueLetters: game.uniqueLetters,
    includedLetters: game.includedLetters,
    notIncludedLetters: game.notIncludedLetters
  }))
}



export function getGameData(): GameData[] {
    return transformRosterData()
}

export function getClubsData(): Club[] {
    return rosterClubs.map(club => ({ name: club.name }))
}

export function getPlayerName(player: Player | string): string {
  if (typeof player === 'string') {
    return player
  }
  return player.surname
}
